<div style="font-weight: normal; padding: 1.5rem 1.5rem 0px 1.5rem">
	<span fxFlex="85">
		<h2 mat-dialog-title style="margin-bottom: 0px">{{data.carrierBusinessName}}</h2>
	</span>
</div>

<!--
	CN-8506: kept fields are the carrier-record values that hydrate reliably
	via CN-8504's getCarriersByIds() fetch in ngOnInit:
	  - MC + DOT (both shown side-by-side, like the capacity carrier cards)
	  - Trucks (powerUnits)
	  - Drivers
	  - Main # (phone)
	Lane-context fields (Frequency, DH-O, DH-D, HQ) were removed — they
	require a search/lane context that the Offers page and Offer Analytics
	report don't provide, so they always rendered blank with broken
	alignment. If a future caller needs them back, restructure how data is
	passed instead of putting them back here without a hydration source.
-->
<div class="primary-light-color" style="font-weight: normal; padding: 1.5rem 1.5rem 0px 1.5rem">
	<div fxLayout="row" class="font-size-17">
		<!-- MC + DOT stacked (no flip-toggle), like the capacity carrier cards.
			 Plain text + mat-icon copy buttons reuse the copy-to-clipboard pattern
			 from app-mc-dot-flip-animation but render statically; left-aligns with
			 the carrier-name title above. Falls back to em-dash when both empty. -->
		<div fxFlex>
			<!-- Both rows always render; each cell shows em-dash when its value
				 is missing so the stacked MC/DOT layout stays uniform across
				 carriers with partial FMCSA data. -->
			<div>
				MC/MX: {{ utilService.isNullOrUndefined(data.mc) ? '—' : data.mc }}
				<button
					*ngIf="!utilService.isNullOrUndefined(data.mc)"
					type="button"
					mat-icon-button
					class="copy-icon"
					aria-label="Copy MC/MX"
					(click)="utilService.copyToClipboard(data.mc, COPY_TO_CLIPBOARD_MSGS.MC); $event.stopPropagation()"
				>
					<mat-icon [inline]="true">file_copy</mat-icon>
				</button>
			</div>
			<div>
				DOT: {{ utilService.isNullOrUndefined(data.dot) ? '—' : data.dot }}
				<button
					*ngIf="!utilService.isNullOrUndefined(data.dot)"
					type="button"
					mat-icon-button
					class="copy-icon"
					aria-label="Copy DOT"
					(click)="utilService.copyToClipboard(data.dot, COPY_TO_CLIPBOARD_MSGS.DOT); $event.stopPropagation()"
				>
					<mat-icon [inline]="true">file_copy</mat-icon>
				</button>
			</div>
		</div>

		<!-- The non-MC/DOT cells use cross-axis "start" so they top-align with the
			 first MC/DOT line (matches the carrier-name title above), instead of
			 vertically centering against the 2-line MC/DOT block. -->
		<div fxFlex fxLayoutAlign="center start">
			Trucks: {{ utilService.isNullOrUndefined(data.powerUnits) ? '—' : data.powerUnits }}
		</div>

		<div fxFlex fxLayoutAlign="center start">
			Drivers: {{ utilService.isNullOrUndefined(data.drivers) ? '—' : data.drivers }}
		</div>

		<div fxFlex fxLayoutAlign="end start">
			<!-- Phone may include an extension after ';'. The tel: href and the mask
				 should both operate on the BASE number only; the extension is
				 appended as readable text. (CodeRabbit catch on PR #4709.) -->
			<span *ngIf="!utilService.isNullOrUndefined(data.phone) && data.phone.length > 0; else dashPhone">
				Main #:&nbsp;<a [attr.href]="'tel:' + data.phone.split(';')[0]">{{ data.phone.split(';')[0] | mask: '(000) 000-0000' }}{{ data.phone.split(';')[1] ? (' ext. ' + data.phone.split(';')[1]) : '' }}</a>
			</span>
			<ng-template #dashPhone>Main #: —</ng-template>
		</div>
	</div>
</div>

<mat-dialog-content style="padding: 1.5rem 1.5rem 1rem 1.5rem; margin: 1px">
	<div>
		<h3 style="font-weight: 100">Representatives</h3>
	</div>

	<div>
		<div>
			<app-carrier-contacts
				[carrierId]="this.data.carrierId"
				[carrier]="null"
				[contactList]="contactList"
				[editPrimaryContact]="data.editPrimaryContact"
				[isCarrierProfile]="true"
				[oldCarrierId]="null"
				[logCallLoadId]="data.logCallLoadId"
				[logCallBidId]="data.logCallBidId"
				[showBidContactsInfo]="!!data.logCallBidId"
				(contactLogged)="onContactLogged($event)"
			>
			</app-carrier-contacts>
		</div>

		<div *ngIf="!contactList?.length" fxLayout="row" fxLayoutAlign="top left" fxLayoutGap="1rem">
			<div fxFlex="100" fxLayoutAlign="center center">
				<h5>No contacts available.</h5>
			</div>
		</div>

		<div *ngIf="data.isFeedbackEnabled && USER_ACCOUNT_TYPE != ACCOUNT_TYPE.ADMIN" fxLayout="row">
			<app-carrier-contacts-feedback
				(emitUserResponse)="allQuestionsAnswered($event)"
				[capacitySearch]="capacitySearch"
				fxFlex="100"
			></app-carrier-contacts-feedback>
		</div>
	</div>
</mat-dialog-content>

<mat-dialog-actions style="padding: 1.5rem 1.5rem 1rem 1.5rem; margin: 1px">
	<div
		*ngIf="!data.isFeedbackEnabled || USER_ACCOUNT_TYPE == ACCOUNT_TYPE.ADMIN "
		fxFlex="100"
		fxLayoutAlign="end end"
	>
		<button (click)="closeDialog()" cdkFocusInitial color="primary" mat-raised-button>Done</button>
	</div>

	<div
		*ngIf="data.isFeedbackEnabled && USER_ACCOUNT_TYPE != ACCOUNT_TYPE.ADMIN"
		fxFlex="100"
		fxLayoutAlign="end end"
	>
		<div fxFlex>
			<app-account-mapping
				(customerCarrierUpdated)="isCustomerCarrierUpdated = true; data.isCustomerCarrier = $event;"
				[carrierId]="data.carrierId"
				[isCustomerCarrier]="data.isCustomerCarrier"
			></app-account-mapping>
		</div>
		<div fxFlex="18" fxLayoutAlign="end end">
			<button
				(click)="submitFeedback()"
				*ngIf="userResponseSegmentPayload != null"
				color="primary"
				mat-raised-button
			>
				Done
			</button>
		</div>
	</div>
</mat-dialog-actions>
